const basicActionTypes = {
    projectTemplateDeploymentProcessAdded: "project_template_deployment_process_added",
    projectTemplateStatusDismissed: "project_template_status_dismissed",
} as const;

export const projectTemplateStatusActions = {
    ...basicActionTypes,
    projectTemplateStatusInitiated: "project_template_status_initiated",
    projectTemplateStatusCreated: "project_template_status_created",
    projectTemplateServerStateLoaded: "project_template_server_state_loaded",
} as const;

type BasicAction = {
    type: (typeof basicActionTypes)[keyof typeof basicActionTypes];
};

type ProjectTemplateStatusInitiatedAction = {
    type: typeof projectTemplateStatusActions.projectTemplateStatusInitiated;
};

type ProjectTemplateStatusCreatedAction = {
    type: typeof projectTemplateStatusActions.projectTemplateStatusCreated;
};

type ProjectTemplateServerStateLoadedAction = {
    type: typeof projectTemplateStatusActions.projectTemplateServerStateLoaded;
    serverState: {
        HasSteps: boolean;
        HasPublishedVersions: boolean;
        HasSharedToSpaces: boolean;
    };
};

export type ProjectTemplateStatusAction = BasicAction | ProjectTemplateStatusInitiatedAction | ProjectTemplateStatusCreatedAction | ProjectTemplateServerStateLoadedAction;
